/// <reference path="../_all.ts" />

module navigation {

  ItemNavigationDirective.$inject = [
    '$filter', 
    '$timeout', 
    '$rootScope',
    'pageMetaService', 
    'anchorNavService', 
  ];
  export function ItemNavigationDirective(
    $filter:ng.IFilterService, 
    $timeout : ng.ITimeoutService, 
    $rootScope:ng.IRootScopeService, 
    pageMetaService: navigation.IPageMetaService, 
    anchorNavService : navigation.IAnchorNavService
  ): ng.IDirective {

    return {
      restrict: 'AE',
      scope: {
        itemData: '=',
        selectedItem: '=',
        onSelect: '&',
        groupFilter: '=',
        nameProperty: '@',
        center: '@',
        allwaysShowArrows: '@',
        headingLevel: '@',
      },
      templateUrl: 'navigation/ItemNavigationDirective',
      link: function (scope: IItemNavScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        
        scope.meta = pageMetaService.getPageMeta;
        scope.nameProperty = angular.isDefined(scope.nameProperty) ? scope.nameProperty: 'Name';

        var dragDealerRoot : JQuery<Element> = angular.element(element[0].querySelector('.dragdealer'));
        scope.dd = new Dragdealer(dragDealerRoot[0], { loose: true });

        var offset : number = 0;
        var maskWidth: number = 0;
        var parentWidth: number = 0;
        var itemPercentMap: { [index: string]: number } = {};
        scope.noArrow = false;
        scope.allwaysShowArrows = angular.isDefined(scope.allwaysShowArrows) ? scope.allwaysShowArrows: false;
        
        

        var layout = () => {

          if (scope.itemData) {

            //postpone layout if not visibile
            if (!element.is(':visible')) {
              var unsubscribe = $rootScope.$on("itemNavSelectedItemChanged", () => {
                $timeout(()=>{
                  if (element.is(':visible')) {
                    unsubscribe();
                    layout();
                  }
                });
              });
              return;
            }


            scope.itemData.forEach((item, index, arr) => {
              if (item['UrlKey']) {
                var nsi : navigation.AnchorNavItem = anchorNavService.addElement(item['UrlKey'], $(element)[0], () : boolean => { 
                  return scope.selectedItem == item;
                });
                item.$anchorNav = nsi;
              }
            });
           

            
            maskWidth = dragDealerRoot.prop('offsetWidth');
            parentWidth = angular.element(dragDealerRoot.children()[0]).prop('scrollWidth');
            parentWidth = Math.max(parentWidth - maskWidth, maskWidth); //2 times maskWith / 2 beacuse the selected element should be in the middle


            var childs = dragDealerRoot.find("li");

            calcWidth(0);
            
            //is the current selectedItem in itemData? (not when itemData changed!)
            var selected : ItemNavItem[] = scope.filteredItem.filter(function (item : ItemNavItem, index :number, array : ItemNavItem[]) {
              return item == scope.selectedItem;
            });

            if (selected.length > 0) {
              scope.setSelectedItem(selected[0], true);
            } else {
              scope.setSelectedItem(scope.filteredItem[0], true); //if none, select first item.
            }

          }
        }

        var calcWidth = function (lastTotalWidth : number) {
          var childs = dragDealerRoot.find("li");

          // var childs = dragDealerRoot.find("li");
          var totChildWidth = 0;

          var elWith: number[] = new Array();
          var elLeft: number[] = new Array();

          for (var i = 0; i < childs.length; i++) {
            //elWith[i] = $(childs[i]).outerWidth(true); // rounding => bad
            elWith[i] = parseFloat(window.getComputedStyle(childs[i])['width'])
              + parseFloat(window.getComputedStyle(childs[i])['margin-left'])
              + parseFloat(window.getComputedStyle(childs[i])['margin-right']);

            //var rect = $(childs[i])[0].getBoundingClientRect();
            //elWith[i] = rect.right - rect.left;
            elLeft[i] = totChildWidth;
            totChildWidth += elWith[i];
          }

          totChildWidth = Math.ceil(totChildWidth + 1)

          angular.element(dragDealerRoot.children()[0]).width(totChildWidth);
          scope.dd.reflow();

          scope.isCentered = scope.center && totChildWidth <= parentWidth;
          scope.noArrow = !scope.allwaysShowArrows && totChildWidth <= maskWidth;

          for (var i = 0; i < childs.length; i++) {
            //var value = childs[i].data().value;
            var elementWith: number = elWith[i];
            var elementLeft: number = elLeft[i];


            var xEl: number = (elementLeft + elementWith / 2) - (maskWidth / 2);
            var percent: number = (xEl / (totChildWidth - maskWidth));
            percent = Math.max(percent, 0);
            percent = Math.min(percent, 1);
            if (totChildWidth < maskWidth) percent = 0;
            if (angular.element(childs[i]).data().$scope) { //gegen Fehler bei schnellem wechsel der produkte.
              itemPercentMap[angular.element(childs[i]).data().$scope.item[scope.nameProperty]] = percent;
            }
          }

          console.log("recalc: old: " + lastTotalWidth + "; new: " + totChildWidth);

          
          if (totChildWidth !== lastTotalWidth) {
            $timeout(()=>{
              calcWidth(totChildWidth);
            }, 5000);
          }
        }

        scope.$on('ngRepeatFinished', function() {
          $timeout(()=>{
            layout();
          })
        });
        
        scope.setSelectedItem = (item: ItemNavItem, dontNavigate? : boolean) => {
          if (!item) return;

          if (!scope.isCentered)  {
            //console.log(item[scope.nameProperty] + ": " + itemPercentMap[item[scope.nameProperty]]);
            scope.dd.setValue(itemPercentMap[item[scope.nameProperty]]);
          } else {
            scope.dd.setValue(0.5) //50%
          }

          scope.selectedItem = item;
          scope.onSelect(item);
          scope.first = scope.filteredItem.indexOf(item) === 0;
          scope.last = scope.filteredItem.indexOf(item) === scope.filteredItem.length - 1;
          $rootScope.$broadcast("itemNavSelectedItemChanged");
          if (!dontNavigate && item.$anchorNav) anchorNavService.setActive(item.$anchorNav); 
        }

        scope.next = () => {
          for (var i = 0; i < scope.filteredItem.length; i++) {
            if (scope.filteredItem[i] == scope.selectedItem) {              
              scope.setSelectedItem(scope.filteredItem[i + 1]);
              return;
            }
          }
        }

        scope.previous = () => {
          for (var i = 0; i < scope.filteredItem.length; i++) {
            if (scope.filteredItem[i] == scope.selectedItem) {
              scope.setSelectedItem(scope.filteredItem[i - 1]);
              return;
            }
          }
        }

        scope.getUrl = (item : ItemNavItem) : string => {
          if (!item['UrlKey']) return "";
          return scope.meta('hlPrefix') + scope.meta().RouteData.BasePageUrl + item['UrlKey'];
        }
        


      }
    }
  }

}